import { render } from "./FullScreenLoader.vue?vue&type=template&id=62a9dde6&scoped=true"
const script = {}

import "./FullScreenLoader.vue?vue&type=style&index=0&id=62a9dde6&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a9dde6"]])

export default __exports__